import { Grid, Skeleton } from "@mzc-pdc/ui";
import React from "react";

const MetadataSkeletonCreateAsset = () => {
    return (
        <Grid container gap={2.5}>
            {new Array(5).fill("").map((_, index) => (
                <Grid container flexDirection={"row"}>
                    <Grid item flex={0.25}>
                        <Skeleton variant={"rounded"} animation={"wave"} height={30} width={120} />
                    </Grid>
                    <Grid item flex={1}>
                        <Skeleton variant={"rounded"} animation={"wave"} height={38} />
                    </Grid>
                </Grid>
            ))}
        </Grid>
    );
};

export default MetadataSkeletonCreateAsset;
